import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Solicitud } from '../models/t2_solicitud.model';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SolicitudesService {

  constructor(private http: HttpClient) { }

  getToken(): string {
    return <string>localStorage.getItem('access_token');
  }

  // Método para crear headers con el token
  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Authorization': `Bearer ${this.getToken()}`
    });
  }

  // Métodos para paginación
  getPages(pageSize: number, usuario: Solicitud): Observable<any> {
    const headers = this.getHeaders();
    let params = new HttpParams();
    params = params.append('index', usuario.t2_numero_registro || '');
    params = params.append('size', pageSize);
    return this.http.get<any>(`${environment.apiUrl}/solicitudes/paginar`, { headers, params });
  }

  getDataId(usuario: Solicitud): Observable<Solicitud> {
    const headers = this.getHeaders();
    return this.http.get<Solicitud>(`${environment.apiUrl}/solicitudes/${usuario.t2_id}`, { headers });
  }

  getDataFilter(page: any, filtro: Solicitud): Observable<Solicitud[]> {
    const headers = this.getHeaders();
    let params = new HttpParams();
    params = params.append('index', filtro.t2_numero_registro || '');
    if(page!=0){
      params = params.append('size', page.size);
      params = params.append('offset', page.offset);
    }
    return this.http.get<Solicitud[]>(`${environment.apiUrl}/solicitudes`, { headers, params });
  }




  postData(demostracion: Solicitud): Observable<any> {
    const headers = this.getHeaders();
    const formData = new FormData();
    formData.append('data', JSON.stringify(demostracion));
    return this.http.post<any>(`${environment.apiUrl}/solicitudes`, formData, { headers });
  }


  descargarData(get_data: Solicitud): Observable<Blob> {
    const form_data = new FormData();
    form_data.append('data',JSON.stringify(get_data));
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.getToken()}`
    });
    return this.http.post<Blob>(`${environment.apiUrl}/solicitudes/reporte/pdf`, form_data, {
      headers: headers,
      responseType: 'blob' as 'json' // Asegura que la respuesta se maneje como un blob
    });
  }





  putData(usuario: Solicitud): Observable<any> {
    const headers = this.getHeaders();
    const formData = new FormData();
    formData.append('data', JSON.stringify(usuario));
    return this.http.put<any>(`${environment.apiUrl}/solicitudes/${usuario.t2_id}`, formData, { headers });
  }

  deleteData(usuario: Solicitud): Observable<any> {
    const headers = this.getHeaders();
    return this.http.delete<any>(`${environment.apiUrl}/solicitudes/${usuario.t2_id}`, { headers });
  }

}
